import { Link } from 'react-router-dom';
import { PageText } from '../../Text/Text';
import styles from './ProductPageNavCard.module.css';


export const ProductPageNavCard = ({
    product,
    productDirectionConfig,
    gridConfig,
    stylesProp,
    href,
}) => {

    

    if (!product) {
        return null; // clearly handle missing product
    }
    if (!href) {
        return null; // clearly handle missing product
    }


    const { title, subtitle, image } = product;

    return (

        <div className={styles.productNavCardContainer}
            style={{
                padding: gridConfig.productNavCardPadding,
                borderBottomRightRadius: gridConfig.productNavCardBorderBottomRightRadius,
                borderBottomLeftRadius: gridConfig.productNavCardBorderBottomLeftRadius
            }}
        >
            <Link to={href}>
                <div style={{ margin: gridConfig.productNavCardMargin }} className={`${styles.productNavCardWrapper} ${styles[stylesProp] || ''}`}>

                    <div className={styles.productNavCardItem1}
                        style={{
                            gridColumn: gridConfig?.textCol,
                            flexDirection: gridConfig?.flexDirection,
                            padding: gridConfig?.navCardItem1Padding,
                        }}>
                        <div className={styles.productText} style={{ textAlign: gridConfig?.textAlign }}>
                            <PageText type='productSearchTitle' >
                                <span className={styles.clampedSubtitle}>{title}</span>
                            </PageText>
                            {/* <PageText color='lightGrayText' type='productSearchSubtitle' >
                            <span className={styles.clampedSubtitle}>{subtitle}</span>
                        </PageText> */}
                        </div>
                        <div className={styles.directionComponentText} style={{ alignSelf: gridConfig?.alignSelf }}>
                            {productDirectionConfig}
                        </div>
                    </div>


                    <div className={styles.productNavCardItem2}
                        style={{
                            gridColumn: gridConfig?.imgCol,
                            padding: gridConfig?.navCardItem2Padding,
                        }}>
                        <div className={styles.realtedProductImageWrapper}>
                            <img
                                loading='lazy'
                                className={styles.relatedProductImage}
                                src={`${process.env.REACT_APP_AWS_URL}/${image}`}
                                alt={`product ${title}`}
                            />
                        </div>
                    </div>
                </div>
            </Link>
        </div>

    );
};
